// import {
//     temAcesso
// } from '@/shared/auth/temAcesso'
import contratacoesRotas from './contratacoes/ContratacoesRotas'
import entregasRotas from './entregas/EntregasRotas'
import finalizacoesRotas from './finalizacoes/FinalizacoesRotas'

export default {
    path: 'fornecedor',
    name: 'FornecedorCred',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    // beforeEnter: (to, from, next) => {
    //     if (to.name === 'Gestores') {
    //         if (temAcesso('UABS-00')) {
    //             next()
    //         }
    //     } else {
    //         next()
    //     }
    // },
    children: [
        contratacoesRotas,
        entregasRotas,
        finalizacoesRotas
    ]
}
